/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
  

(function() {
  // Add custom code below this line

  $('.accordian').toggle();
/*$(".iwish-backdrop").bind( "click", function() {
    console.log("Hello");
     window.cart.getCart();
  });

$(".iwish-backdrop").trigger( "click" );	*/

  $('.sliderule__wrapper').on('click',function(e){
    console.log($(this));
	  $(this).find('.accordian').toggle('slow');
  })
  //console.log("Cart Update");
  
  $('.newsletter-open').on('click',function(e){
    console.log("nl");
    $('.newsletter-toggle').removeClass('hidden');
  })
  $('.close-nl').on('click',function(e){
    console.log("nl");
    $('.newsletter-toggle').addClass('hidden');
  })     



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


 


//var backdrop = document.getElementsByClassName("iwish-backdrop").click();

